import Proposal from 'components/proposal-list-page/Proposal';

import { IProposalCardList } from 'source/NFR.types';

const ProposalCardList: React.FC<IProposalCardList> = ({ proposals }) => {
  if (!proposals?.length) return null;
  return (
    <div className="proposal-card-list">
      {proposals?.map(proposal => (
        <Proposal headingLevel={2} key={proposal.id} {...proposal} />
      ))}
    </div>
  );
};

ProposalCardList.displayName = 'ProposalCardList';

export default ProposalCardList;
